export default "__VITE_ASSET__DQKPt5nS__"